import { useState, FormEvent } from 'react';
import { useMutation } from '@tanstack/react-query';
import { useNavigate, Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { useToast } from '../hooks/use-toast';
import { registerUser } from '../services/api';

export default function Register() {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();
    const { toast } = useToast();

    const registerMutation = useMutation({
        mutationFn: () => registerUser({ name, email, password }),
        onSuccess: () => {
            toast({
                title: 'Cadastro realizado!',
                description: 'Seu cadastro foi enviado. Aguarde a aprovação do administrador.',
            });
            navigate('/login');
        },
        onError: (error: any) => {
            const errorMessage =
                error.response?.data?.detail ||
                error.response?.data?.message ||
                'Erro ao realizar cadastro';

            toast({
                variant: 'destructive',
                title: 'Erro no cadastro',
                description: errorMessage,
            });
        },
    });

    const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (!name || !email || !password) {
            toast({
                variant: 'destructive',
                title: 'Campos obrigatórios',
                description: 'Por favor, preencha todos os campos.',
            });
            return;
        }

        registerMutation.mutate();
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
            <div className="w-full max-w-md p-8 space-y-6 bg-white rounded-lg shadow-md">
                <div className="text-center">
                    <h1 className="text-3xl font-bold text-gray-900">Criar conta</h1>
                    <p className="mt-2 text-sm text-gray-600">
                        Preencha os dados para solicitar acesso
                    </p>
                </div>

                <form onSubmit={handleSubmit} className="space-y-4">
                    <div className="space-y-2">
                        <Label htmlFor="name">Nome</Label>
                        <Input
                            id="name"
                            type="text"
                            placeholder="Seu nome"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            disabled={registerMutation.isPending}
                        />
                    </div>

                    <div className="space-y-2">
                        <Label htmlFor="email">Email</Label>
                        <Input
                            id="email"
                            type="email"
                            placeholder="seu@email.com"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            disabled={registerMutation.isPending}
                        />
                    </div>

                    <div className="space-y-2">
                        <Label htmlFor="password">Senha</Label>
                        <Input
                            id="password"
                            type="password"
                            placeholder="••••••••"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            disabled={registerMutation.isPending}
                        />
                    </div>

                    <Button
                        type="submit"
                        className="w-full"
                        disabled={registerMutation.isPending}
                    >
                        {registerMutation.isPending ? 'Enviando...' : 'Solicitar acesso'}
                    </Button>
                </form>

                <p className="text-center text-sm text-gray-600">
                    Já tem conta?{' '}
                    <Link to="/login" className="font-medium text-blue-600 hover:underline">
                        Fazer login
                    </Link>
                </p>
            </div>
        </div>
    );
}
